import * as types from "./types";
import {
    getItemReorderingByItemIDAxios,addJCByItemIDAxios,addPOByItemIDAxios
} from "./services";

export async function getItemReorderingByItemIDAction({ commit },payload) {
    commit(types.LOADING_ITEM, true);
    try {
        const { data } = await getItemReorderingByItemIDAxios(payload);
        commit(types.GET_ITEMREORDERING_ID, data.result);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_ITEM, false);
    }
}

export async function addJCByItemIDAction({ commit },payload) {
    commit(types.LOADING_ITEM, true);
    try {
        const { data } = await addJCByItemIDAxios(payload);
        commit(types.ADD_JC_BY_ITEMID, data.result);
        return data.result;
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_ITEM, false);
    }
}
export async function addPOByItemIDAction({ commit },payload) {
    commit(types.LOADING_ITEM, true);
    try {
        const { data } = await addPOByItemIDAxios(payload);
        commit(types.ADD_PO_BY_ITEMID, data.result);
        return data.result;
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_ITEM, false);
    }
}